/**
 * Calculate the percentage difference between original and calculated price.
 * @param original - Original price
 * @param calculated - Calculated (discounted) price
 * @returns Percentage difference as a string (e.g., "20" for 20% off)
 */
export const getPercentageDiff = (
  original: number,
  calculated: number
): string => {
  if (original <= 0) {
    return '0';
  }
  const diff = original - calculated;
  const decrease = (diff / original) * 100;
  return decrease.toFixed();
};
